// Componente per sistema ExeDialog DDT2026 - Step cig e cup
import React, { useState, useRef, useEffect } from 'react';
import { InputText } from 'primereact/inputtext';
import { ValoriVerificati } from './ValoriVerificati';

export function Cig(props) {
    const { currURLSearchParams, onFinish, verificaData } = props;
    const inputRef = useRef();
    
    // I valori suggeriti possono venire dalla selezione targa
    const [state, setState] = useState({
        cig: currURLSearchParams.get('cig') || 'NO',
        cup: currURLSearchParams.get('cup') || 'NO'
    });

    useEffect(() => {
        if (inputRef.current) {
            inputRef.current.focus();
        }
    }, [verificaData]);

    const handleSubmit = (e) => {
        e.preventDefault();
        if (state.cig && state.cup) {
            onFinish({
                cig: state.cig,
                cup: state.cup
            });
        }
    };

    return (
        <div className="card-body">
            <h5 className="card-title">CIG e CUP</h5>
            <p className="text-muted">Inserisci i codici CIG e CUP.</p>
            
            <form onSubmit={handleSubmit}>
                <div className="mb-3">
                    <label htmlFor="cig" className="form-label">CIG (Codice Identificativo Gara)</label>
                    <InputText 
                        ref={inputRef}
                        id="cig"
                        value={state.cig}
                        onChange={(e) => setState({...state, cig: e.target.value})}
                        className="w-100"
                    />
                </div>

                <div className="mb-3">
                    <label htmlFor="cup" className="form-label">CUP (Codice Unico Progetto)</label>
                    <InputText 
                        id="cup"
                        value={state.cup}
                        onChange={(e) => setState({...state, cup: e.target.value})}
                        className="w-100"
                    />
                </div>

                <button className="btn btn-primary" disabled={!state.cig || !state.cup}>
                    Prosegui
                </button>
            </form>
            
            <ValoriVerificati valori={verificaData?.valori_verificati} />
        </div>
    );
}

Cig.displayName = 'cig';
